import { render, staticRenderFns } from "./ColumnDrag.vue?vue&type=template&id=403a9c53&scoped=true&"
import script from "./ColumnDrag.vue?vue&type=script&lang=js&"
export * from "./ColumnDrag.vue?vue&type=script&lang=js&"
import style0 from "./ColumnDrag.vue?vue&type=style&index=0&id=403a9c53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403a9c53",
  null
  
)

export default component.exports